/**
 * Bump when OrderingBasketSnapshot changes shape — old baskets then reset.
 * 2: a null option quantity always follows the line. A v1 null could be an unstepped option the server charges once.
 */
export const BASKET_SCHEMA_VERSION = 2

/** A basket older than this is stale; a sitting does not last six hours. */
export const BASKET_TTL_MS = 6 * 60 * 60 * 1000

/** The most of one option a line may carry — `items.*.addons.*.quantity` allows up to 99. */
export const OPTION_QUANTITY_CEILING = 99
